import React from "react"
import styled from "styled-components"

const PageTitle = ({ children, className = "random" }) => {
  return <Container className={className}>{children}</Container>
}

const Container = styled.h2`
  font-size: 48px;
  font-weight: bold;
  margin-bottom: 20px;
  margin-left: 20px;
  color: #071f35;
`

export default PageTitle
